import { useEffect, useState } from "react";
import { Facebook, Mail, Send, Users } from "lucide-react";
import Layout from "@/components/Layout";
import { api } from "@/lib/api";

export default function Connect() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => setSettings({}));
  }, []);

  const fb = settings?.facebook_url;
  const email = settings?.contact_email || "dceptnz@gmail.com";

  return (
    <Layout>
      <section className="border-b border-slate-200 bg-white">
        <div className="max-w-[1280px] mx-auto px-5 lg:px-8 py-14">
          <div className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#059669] mb-3">Connect</div>
          <h1 className="font-serif text-4xl lg:text-5xl text-[#11181C] tracking-tight">Have a lead or local story?</h1>
          <p className="mt-4 text-[#52606D] max-w-2xl leading-relaxed">
            We're building this archive in public. If you know of a project we should be tracking, follow along or get in touch.
          </p>
        </div>
      </section>

      <section className="max-w-[1280px] mx-auto px-5 lg:px-8 py-12 grid lg:grid-cols-2 gap-8">
        <div className="space-y-8">
        {/* Facebook */}
        <div className="bg-white border border-slate-200 rounded-xl p-8">
          <div className="w-12 h-12 rounded-lg bg-[#1877F2]/10 flex items-center justify-center mb-5"><Facebook className="text-[#1877F2]" /></div>
          <h2 className="font-serif text-2xl text-[#11181C]">Follow on Facebook</h2>
          <p className="text-[#52606D] mt-3 leading-relaxed text-sm">
            Updates, commentary and community discussion from the Data Centre Exposure Project.
          </p>
          {fb ? (
            <>
              <a href={fb} target="_blank" rel="noreferrer" className="mt-5 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#1877F2] text-white text-sm font-medium hover:brightness-110 transition" data-testid="facebook-link">
                Open our Facebook page <Send size={14} />
              </a>
              <div className="mt-6 rounded-lg overflow-hidden border border-slate-200">
                <iframe
                  title="Facebook page"
                  src={`https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(fb)}&tabs=timeline&width=500&height=500&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true`}
                  width="100%" height="500" style={{ border: "none", overflow: "hidden" }} scrolling="no" frameBorder="0" allow="encrypted-media"
                />
              </div>
            </>
          ) : (
            <p className="mt-5 text-sm text-[#64748B] italic">The Facebook page will appear here once connected by an administrator.</p>
          )}
        </div>

        {/* Stop Data Centres NZ group */}
        <div className="bg-white border border-slate-200 rounded-xl p-8" data-testid="stop-dc-group-card">
          <div className="w-12 h-12 rounded-lg bg-[#1877F2]/10 flex items-center justify-center mb-5"><Users className="text-[#1877F2]" /></div>
          <h2 className="font-serif text-2xl text-[#11181C]">Stop Data Centres New Zealand</h2>
          <p className="text-[#52606D] mt-3 leading-relaxed text-sm">
            A community Facebook group for people across New Zealand sharing news, concerns and local updates about data centre developments.
          </p>
          <a href="https://www.facebook.com/groups/1317860103076920/" target="_blank" rel="noreferrer" className="mt-5 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#1877F2] text-white text-sm font-medium hover:brightness-110 transition" data-testid="stop-dc-group-link">
            Join the group <Send size={14} />
          </a>
        </div>
        </div>

        {/* Contact */}
        <div className="bg-[#0B0F17] text-white rounded-xl p-8 dcep-grain h-fit">
          <div className="w-12 h-12 rounded-lg bg-emerald-500/15 flex items-center justify-center mb-5"><Mail className="text-emerald-400" /></div>
          <h2 className="font-serif text-2xl">Share a lead</h2>
          <p className="text-white/60 mt-3 leading-relaxed text-sm">
            Seen something being built? Have planning documents, grid connection notices or a local story? We'd like to hear from you.
          </p>
          <a href={`mailto:${email}`} className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white text-[#0B0F17] text-sm font-medium hover:bg-emerald-400 transition" data-testid="contact-email-link">
            {email}
          </a>
          <div className="mt-8 pt-6 border-t border-white/10 text-sm text-white/50 leading-relaxed">
            All correspondence is treated in confidence. This project is independent and non-commercial.
          </div>
        </div>
      </section>
    </Layout>
  );
}
